<template>
  <div class="wrapper perfect-theme-design">
    <!-- <div v-if="isUpdate"></div> -->
    <div class="content">
      <div class="title">{{ title }}配置</div>
    </div>
    <div class="content">
      <div class="title">
        <div>
          <el-button v-if="type !== 'view'" type="primary" size="mini" plain @click="handleAddRow()">新增</el-button>
        </div>
        <div :inline="true" :model="formDesign" class="demo-form-inline">
          <el-input class="iptSize" size="mini" v-model="formDesign.defineName" clearable placeholder="套餐名称" style="width:120px;"></el-input>
          <el-select class="iptSize" size="mini" v-model="formDesign.rowColumn" clearable filterable  placeholder="堆箱规格">
            <el-option v-for="(item,index) in sizeOptions" :key="index" :label="item" :value="item"></el-option>
          </el-select>
          <el-select class="iptSize" size="mini" v-model="formDesign.stackPackSubBrands" clearable filterable  placeholder="子品牌">
            <el-option v-for="item in subBrandOptions" :key="item.abiBrandId" :label="item.abiBrandName" :value="item.abiBrandCode"></el-option>
          </el-select>
          <el-button type="danger" size="mini" plain @click="onSubmit">搜索</el-button>
          <el-button type="primary" size="mini" plain @click="handleResst">重置</el-button>
        </div>
      </div>
    </div>
    <div v-if="mixPackListPagination.length">
      <div class="info">
        <el-row v-if="!isView" :gutter="20" class="header" type="flex" align="middle" justify="center" style="margin:0 0 20px 0;">
          <el-col :span="2">序号</el-col>
          <el-col :span="3">
            <span class="require">套餐名称</span>
          </el-col>
          <el-col :span="7">
            <span class="require">堆箱信息</span>
          </el-col>
          <el-col :span="7">
            <span class="require">产品信息</span>
          </el-col>
          <el-col :span="5">操作</el-col>
        </el-row>
        <el-row v-else :gutter="20" class="header" type="flex" align="middle" justify="center" style="margin:0 0 20px 0;">
          <el-col :span="3">序号</el-col>
          <el-col :span="4">
            <span>套餐名称</span>
          </el-col>
          <el-col :span="8">
            <span>堆箱信息</span>
          </el-col>
          <el-col :span="9">
            <span>产品信息</span>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-for="(item, index) in mixPackListPagination" :key="index" class="detail">
          <div style="display: flex; align-items: center;; justify-content: center;">
          <el-col :span="isView?3:2" style="line-height:32px">{{item.sequenceFlag}}</el-col>
          <el-col :span="isView?4:3">
            <el-tooltip effect="light" :content="item.defineName" placement="top" :disabled="!isView">
              <el-input v-model="item.defineName" size="mini" clearable filterable placeholder="套餐名称" :disabled="isView" />
              <!-- @blur="checkName" -->
            </el-tooltip>
          </el-col>

          <el-col :span="isView?8:7">
            <div class="product-info" v-if="item.stackPackSize">
              <div class="design-thumbnail" :class="(item.brandList && item.brandList.length) < 12?'center':''" title="查看详情" @click="showStackInfoDialog(findIndex(item.sequenceFlag))">
                <div class="design-thumbnail-column" v-for="(cItem, cIndex) in item.brandList" :key="cIndex">
                  <div
                    class="design-thumbnail-row"
                    v-for="(rItem, rIndex) in getLine('row', index)"
                    :key="rIndex"
                    :style="`background:${cItem.tradeStackColor}`"
                  ></div>
                </div>
              </div>
            </div>
            <!-- && !isDetailPage -->
            <div
              v-if="!mixPackList[findIndex(item.sequenceFlag)].scopeDefineId && item.stackPackSize"
              class="stack-design-modify product-info"
              @click="showStackInfoDialog(findIndex(item.sequenceFlag))"
            >修改</div>
            <el-button type="success" plain @click="showStackInfoDialog(findIndex(item.sequenceFlag))" v-if="!item.stackPackSize">添加</el-button>
          </el-col>
          <el-col :span="isView?9:7">
            <div v-if="item.tradePerfectScopeDetailList.length !== 0">
              <div v-for="(product, index) in item.tradePerfectScopeDetailList" :key="index">
                <div class="product-info">
                  {{
                  `${product.brandName}-
                  ${product.subBrandName}-
                  ${product.volume}-
                  ${product.multiPackSpec}-
                  ${product.minDisplayQty}件-
                  ${product.rowQty}面`
                  }}
                </div>
              </div>
            </div>
            <!-- item.tradePerfectScopeDetailList[0].brandCode && -->
            <div
              v-if="
                item.tradePerfectScopeDetailList.length !==0 &&
                item.canUpdate
              "
              class="stack-design-modify product-info"
              @click="modifyProductInfo(findIndex(item.sequenceFlag))"
            >修改</div>
            <!-- v-else-if="employeeLevel > 50 && !isDetailPage && item.canUpdate" -->

            <el-button
              v-else-if="item.tradePerfectScopeDetailList.length === 0"
              type="success"
              plain
              @click="showProductInfoDialog(findIndex(item.sequenceFlag))"
            >添加</el-button>
          </el-col>
          <el-col v-if="!isView" :span="5">
            <el-button type="danger" size="mini" plain @click="handleDeleteRow(findIndex(item.sequenceFlag))">删除</el-button>
          </el-col>
          </div>
          <el-col class="checkBox" :span="24">
            <div class="checkBox-title">开放区域:</div>
            <div class="checkBox-main" v-if="isView">
              <div style="margin-right:20px;display: inline-block;" v-for="reginItem in item.regionList" :key="reginItem.orgCode">{{reginItem.orgName}}</div>
            </div>
            <div class="checkBox-main" v-else style="display:flex;align-items: center;">
              <el-checkbox
                class="all color"
                :indeterminate="item.isIndeterminate"
                v-model="item.checkAll"
                @change="handleCheckAllChange($event,index)"
              >{{item.checkAll?'全不选':'全选'}}</el-checkbox>
              <el-checkbox-group  v-model="item.regionCodeList" @change="handleCheckedCitiesChange($event,index)">
                <el-checkbox
                 v-for="regionItem in regionListByBu"
                 :label="regionItem.orgCode"
                 :key="regionItem.orgId"
                 @change="cancelDialog(regionItem,index, item.scopeDefineId||'')">
                 {{regionItem.orgName}}{{getDefineCount(item.scopeDefineId, regionItem.orgCode)?'（' + getDefineCount(item.scopeDefineId, regionItem.orgCode) + '）':''}}
                 </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pagination">
        <el-pagination
          background
          :current-page.sync="pageInfo.currentPage"
          :page-size="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <div v-else style="text-align:center">您暂未配置{{title}}</div>
    <!-- 产品信息弹窗 -->
    <ProductConfigDialog
      ref="productConfigDialog"
      :brandList="customBrandList"
      :specList="specList"
      :sizeList="sizeList"
      :dialogVisible="productDialogVisible"
      @addProductInfo="addProductInfo"
      @closeProductDialog="closeProductDialog"
    />
    <StackConfigDialog ref="stackConfigDialog" :subBrandOptions="subBrandOptions" @confirm="onStackConfigConfirmed"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProductConfigDialog from './product-config-dialog'
import StackConfigDialog from './stack-config-dialog'
export default {
  components: {
    ProductConfigDialog,
    StackConfigDialog
  },
  props: {
    title: {
      type: String,
      default: '组合陈列套餐配置'
    },
    originThemeDefineDTO: {
      type: Object,
      default: () => {
        return {}
      }
    },
    primaryData: {
      type: Array,
      default: () => {
        return []
      }
    },
    customBrandList: {
      type: Array,
      default: () => {
        return []
      }
    },
    regionListByBu: {
      type: Array,
      default: () => {
        return []
      }
    },
    defineCountMap: {
      type: Object,
      default: () => {
        return {}
      }
    },
    regionCancelConfirm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 搜索
      formDesign: {
        defineName: '',
        rowColumn: '',
        stackPackSubBrands: ''
      },
      formSearch: {},
      mixPackList: [],
      // 分页
      pageInfo: {
        currentPage: 1,
        pageSize: 5
      },
      total: 0,
      // 多选
      checkAll: false,
      regionCodeList: [],
      isIndeterminate: true,
      // 弹窗
      productDialogVisible: false,
      stackDialogVisible: false,
      indexSelected: 0,
      brandSelected: [],
      sequenceFlag: 0, // 序号
      row: '',
      column: '',
      designDialogVisible: false
    }
  },
  computed: {
    ...mapState({
      specList: state => state.base.tradePerfectMandatorySpecsMap,
      sizeList: state => state.base.tradePerfectScopeDetailSpecMap
    }),
    mixPackListPagination () {
      // if (!this.mixPackList) return []
      const filteredList = this.mixPackList.filter(item => {
        if (this.formSearch.defineName && item.defineName.toLowerCase().indexOf(this.formSearch.defineName.toLowerCase()) < 0) {
          return false
        }
        if (this.formSearch.rowColumn && (item.row + ' * ' + item.column) !== this.formSearch.rowColumn) {
          return false
        }
        if (this.formSearch.stackPackSubBrands) {
          if (!item.brandList) {
            return false
          }
          const brandArray = item.brandList.map(sItem => {
            return sItem.abiBrandCode
          }) || []
          item.tradePerfectScopeDetailList.map(mixinItem => {
            if (brandArray.indexOf(mixinItem.subBrandCode) < 0) {
              brandArray.push(mixinItem.subBrandCode)
            }
          })
          if (brandArray.indexOf(this.formSearch.stackPackSubBrands) < 0) {
            return false
          }
        }
        return true
      })
      this.setTotal(filteredList.length)
      const startIndex = this.pageInfo.pageSize * (this.pageInfo.currentPage - 1)
      const endIndex = this.pageInfo.pageSize * this.pageInfo.currentPage
      return filteredList.slice(startIndex, endIndex)
    },
    sizeOptions () {
      let arr = []
      let mixPackList = this.autoSort(this.mixPackList)
      mixPackList.forEach(item => {
        if (item.row && item.column) {
          let rowColumn = item.row + ' * ' + item.column
          if (arr.indexOf(rowColumn)) {
            arr.push(rowColumn)
          }
        }
      })
      arr = [...new Set(arr)]
      return arr
    },
    subBrandOptions () {
      return this.originThemeDefineDTO.subBrandList
    },
    getDefineCount () {
      return (scopeDefineId, orgCode) => {
        let key = scopeDefineId + '_' + orgCode
        return this.defineCountMap[key]
      }
    },
    isView () {
      return this.$route.query.type === 'view'
    }

  },
  watch: {
    regionListByBu: {
      deep: true,
      immediate: true,
      handler () {
        this.mixPackList.forEach((item) => {
          if (item.regionList !== null && item.regionList.length === this.regionListByBu.length) {
            item.checkAll = true
          }
        })
      }
    }
  },
  created () {
    this.type = this.$route.query.type
  },
  methods: {
    // 设置基本信息
    setInfo () {
      this.mixPackList = this.primaryData
      this.mixPackList.forEach((item) => {
        this.mixPackList.forEach(item => {
          if (item.sequenceFlag > this.sequenceFlag) {
            this.sequenceFlag = item.sequenceFlag
          }
        })
        if (item.regionList) {
          item.regionList.forEach((region) => {
            region.orgName = region.orgName.substring(0, region.orgName.indexOf('|'))
          })
        }
        this.$set(item, 'row', parseInt(item.stackPackSize.split('*')[0]) || null)
        this.$set(item, 'column', parseInt(item.stackPackSize.split('*')[1]) || null)
        this.$set(item, 'checkAll', false)
        this.$set(item, 'regionCodeList', item.regionCodes ? item.regionCodes.split(',') : [])
      })
    },
    setTotal (total) {
      this.total = total
    },
    // 按照row进行排序
    autoSort (list) {
      // 深拷贝
      let arr = []
      list.forEach(item => {
        arr.push(item)
      })
      let sortList = arr.sort(function (a, b) {
        return a.row - b.row || a.column - b.column
      })
      return sortList
    },
    // 搜索
    onSubmit () {
      this.formSearch = JSON.parse(JSON.stringify(this.formDesign))
      this.pageInfo.currentPage = 1
    },
    // 重置
    handleResst () {
      this.formDesign = {
        defineName: '',
        rowColumn: '',
        stackPackSubBrands: ''
      }
      this.formSearch = {
        defineName: '',
        rowColumn: '',
        stackPackSubBrands: ''
      }
    },
    // 新增
    handleAddRow () {
      if (!this.checkName()) {
        return
      }
      this.sequenceFlag = 0
      this.mixPackList.forEach((item) => {
        if (item.sequenceFlag > this.sequenceFlag) {
          this.sequenceFlag = item.sequenceFlag
        }
      })
      this.formSearch = {}
      this.sequenceFlag++
      const cityOptions = this.regionListByBu.map(item => {
        return item.orgCode
      })
      this.mixPackList.unshift({
        defineType: '04', // 定义类型，01-堆箱 03-必备品 04-组合陈列
        canUpdate: true,
        defineName: '组合套餐' + this.sequenceFlag,
        stackPackSize: '',
        row: '',
        column: '',
        brandList: [],
        regionCodeList: cityOptions,
        checkAll: true,
        sequenceFlag: this.sequenceFlag,
        tradePerfectScopeDetailList: []
      })
    },
    // 删除
    handleDeleteRow (index) {
      let message = '是否确认删除该堆箱类型'
      if (this.mixPackList[index].scopeDefineId && this.$route.query.status !== 0) {
        message = '若删除该任务，则选择该任务的活动都会被禁用！'
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (this.mixPackList.length - 1 === index && index % 5 === 0 && this.pageInfo.currentPage > 1) {
            this.pageInfo.currentPage = this.pageInfo.currentPage - 1
          }
          this.mixPackList.splice(index, 1)
        })
        .catch(() => { })
    },
    // 获取当前数据行/列数据
    getLine (type, index) {
      const sizeInfo = this.mixPackListPagination[index].stackPackSize
        ? this.mixPackListPagination[index].stackPackSize.split('*')
        : []
      if (type === 'row') {
        return Number(sizeInfo[0])
      }
      if (type === 'column') {
        return Number(sizeInfo[1])
      }
    },

    // 检查堆箱名称
    checkName (e) {
      if (e && !e.target.value) {
        this.$message.warning('堆箱设计类型名称不能为空')
        return
      }
      let nameArr = []
      if (this.mixPackList.length) {
        this.mixPackList.forEach(item => {
          nameArr.push(item.defineName)
        })
      }

      if (!this.sortCheckSame(nameArr)) {
        this.$message.warning('堆箱设计类型名称重复')
        return false
      }
      return true
    },
    // 校验套餐重复
    checkSame (stackData, brandSelected, productSelected, indexSelected) {
      const nowSize = stackData.row + '*' + stackData.column
      // 组装当前操作套餐所选的品牌编码字符串
      let nowBrandStr = this.composeStackBrandToStr(brandSelected)
      // TODO 组装产品信息用于比较重复
      let nowProductStr = this.composeProductDataToStr(productSelected)

      // 组装并比较所有列表里相同规格的套餐品牌
      for (let i = 0; i < this.mixPackList.length; i++) {
        if (i === indexSelected) {
          continue
        }
        let item = this.mixPackList[i]
        // 判断堆箱是否相同
        let itemBrandStr = this.composeStackBrandToStr(item.brandList)
        const stackRepeat = item.stackPackSize === nowSize && nowBrandStr === itemBrandStr
        // 判断产品重复
        let itemProductStr = this.composeProductDataToStr(item.tradePerfectScopeDetailList)
        const productRepeat = nowProductStr === itemProductStr
        if (stackRepeat && productRepeat) {
          this.$message.warning(`当前设计与套餐 "${item.defineName}" 重复`)
          return false
        }
      }
      return true
    },
    composeStackBrandToStr (brandList) {
      let brandStr = ''
      if (brandList) {
        let itemBrandArr = []
        brandList.forEach(brandInfo => {
          itemBrandArr.push(brandInfo.abiBrandCode)
        })
        brandStr = itemBrandArr.length ? itemBrandArr.sort().join(',') : ''
      }
      return brandStr
    },
    composeProductDataToStr (productList) {
      let productStr = ''
      if (productList) {
        let itemProductArr = []
        productList.forEach(item => {
          itemProductArr.push(item.brandCode + '-' + item.subBrandCode + '-' + item.volume +
        '-' + item.multiPackSpec + '-' + item.minDisplayQty)
        })
        productStr = itemProductArr.length ? itemProductArr.sort().join(',') : ''
      }
      return productStr
    },
    // 排序查重
    sortCheckSame (checkArr) {
      let arr = Object.assign([], checkArr)
      let checkedResult = true

      if (arr.length) {
        let sortArr = arr.sort()
        for (let i = 0; i < sortArr.length; i++) {
          if (sortArr[i] === sortArr[i + 1]) {
            checkedResult = false
            break
          }
        }
      }
      return checkedResult
    },
    // 显示产品信息弹窗
    showProductInfoDialog (index) {
      // 校验是否有重复的套餐名称
      if (!this.checkName()) {
        return
      }
      this.indexSelected = index
      this.productDialogVisible = true
    },
    // 关闭产品信息弹窗
    closeProductDialog () {
      this.$refs.productConfigDialog.resetData()
      this.productDialogVisible = false
    },
    // 添加产品信息
    addProductInfo (productData) {
      const item = this.mixPackList[this.indexSelected]
      const brandSelected = item.brandList
      if (!this.checkSame(item, brandSelected, productData, this.indexSelected)) {
        return
      }
      this.confirmSetProductData(productData)
    },
    // 通过校验后 将产品信息set进当前页面数组
    confirmSetProductData (productData) {
      this.mixPackList[this.indexSelected].tradePerfectScopeDetailList = productData.slice(0)
      this.closeProductDialog()
    },
    // 修改产品信息
    modifyProductInfo (index) {
      this.showProductInfoDialog(index)
      this.setProductDefaultData()
    },
    // 设置默认产品信息数据
    setProductDefaultData () {
      let arr = this.formatProductData(this.mixPackList[this.indexSelected].tradePerfectScopeDetailList)
      this.$nextTick(() => {
        this.$refs.productConfigDialog.productList = arr
      })
    },
    // 格式化产品信息数据
    formatProductData (arr) {
      arr.forEach(item => {
        item.brandInfo = `${item.brandCode},${item.brandName}`
        item.subBrandInfo = `${item.subBrandCode},${item.subBrandName}`
      })
      return arr
    },
    findIndex (sequenceFlag) {
      let sIndex = 0
      this.mixPackList.forEach((item, index) => {
        if (item.sequenceFlag === sequenceFlag) {
          sIndex = index
        }
      })
      return sIndex
    },
    // 显示堆箱信息弹窗
    showStackInfoDialog (index) {
      if (!this.checkName()) {
        return
      }
      const brandSelected = []
      if (this.mixPackList[index].brandList) {
        this.mixPackList[index].brandList.forEach(item => {
          brandSelected.push(item.abiBrandCode + ',' + item.brandName + ',' + item.tradeStackColor)
        })
      }

      const data = {
        stackData: this.mixPackList[index],
        brandSelected: brandSelected
      }
      const showMode = this.mixPackList[index].scopeDefineId ? 'view' : 'edit'
      const options = {
        indexSelected: index,
        showMode: showMode
      }
      this.indexSelected = index
      this.$refs.stackConfigDialog.show(data, options)
    },
    onStackConfigConfirmed (payload) {
      const stackData = payload.stackData
      const brandSelected = payload.brandSelected || []
      const indexSelected = payload.options.indexSelected
      const productSelected = this.mixPackList[indexSelected].tradePerfectScopeDetailList
      if (!this.checkSame(stackData, brandSelected, productSelected, indexSelected)) {
        return
      }
      // 添加
      this.mixPackList[indexSelected].brandList = []
      brandSelected.forEach(item => {
        let brandInfo = item ? item.split(',') : []
        this.mixPackList[indexSelected].brandList.push({
          abiBrandCode: brandInfo[0],
          brandName: brandInfo[1],
          tradeStackColor: brandInfo[2]
        })
      })
      this.mixPackList[indexSelected].stackType = '02'
      this.mixPackList[indexSelected].row = stackData.row
      this.mixPackList[indexSelected].column = stackData.column
      this.mixPackList[indexSelected].stackPackSize = stackData.row + '*' + stackData.column
      this.$refs.stackConfigDialog.close()
    },
    // 多选
    handleCheckAllChange (val, index) {
      const cityOptions = this.regionListByBu.map(item => {
        return item.orgCode
      })
      if (val) {
        this.mixPackListPagination[index].regionCodeList = cityOptions
        return
      }
      if (this.regionCancelConfirm) {
        this.mixPackListPagination[index].checkAll = true
        this.$confirm('若取消该区域，则该区域选择了此任务的活动都会被禁用！', '是否取消开放该区域', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.mixPackListPagination[index].regionCodeList = []
          this.mixPackListPagination[index].checkAll = false
        }).catch(() => {
          this.mixPackListPagination[index].regionCodeList = cityOptions
          this.mixPackListPagination[index].checkAll = true
        })
      } else {
        this.mixPackListPagination[index].regionCodeList = []
      }
    },
    handleCheckedCitiesChange (value, index) {
      let arr = this.regionListByBu.filter((item, index) => {
        let flag = false
        value.forEach((sItem, sIndex) => {
          if (item.orgCode === sItem) {
            flag = true
          }
        })
        return flag
      })
      this.mixPackListPagination[index].regionCodeList = arr.map((item, index) => item.orgCode)
      let checkedCount = value.length
      this.mixPackListPagination[index].checkAll = checkedCount === this.regionListByBu.length
      this.mixPackListPagination[index].isIndeterminate = checkedCount > 0 && checkedCount < this.regionListByBu.length
    },
    // region单选取消弹窗
    cancelDialog (item, index, scopeDefineId) {
      let message = ''
      let key = scopeDefineId + '_' + item.orgCode
      if (this.defineCountMap[key] !== undefined) {
        message = '此任务已被该区域的' + this.defineCountMap[key] + '个活动引用，'
      }
      if (this.mixPackListPagination[index].regionCodeList.indexOf(item.orgCode) === -1 && this.regionCancelConfirm) {
        this.$confirm(message + '若取消区域，则区域选择了此任务的活动都会被禁用！', '是否取消开放该区域', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          // this.$message.success('已取消')
        }).catch(() => {
          this.mixPackListPagination[index].regionCodeList.push(item.orgCode)
        })
      }
    },
    getMixinDisplayScopeInfo (taskType) {
      let params = this.mixPackList.map(item => {
        item.str = []
        if (item.stackType === '01') {
          // for (let i = 0; i < Number(item.column); i++) {
          //   item.str.push(item.subBrandCode)
          // }
          if (item.brandCode) {
            item.stackPackBrands = item.brandCode
            item.stackPackSubBrands = item.subBrandCode
          }
        } else if (item.stackType === '02') {
          if (item.brandList) {
            item.stackPackSubBrands = item.brandList.map(item => {
              return item.abiBrandCode
            }).join(',')
          }
        }
        return {
          scopeDefineId: item.scopeDefineId,
          defineType: '04',
          taskType: taskType,
          defineName: item.defineName,
          stackPackSize: item.stackPackSize,
          regionCodes: item.regionCodeList.join(','),
          stackPackBrands: item.stackPackBrands,
          stackPackSubBrands: item.stackPackSubBrands,
          sequenceFlag: item.sequenceFlag,
          stackType: item.stackType,
          tradePerfectScopeDetailList: item.tradePerfectScopeDetailList
        }
      })
      return params
    },
    checkData (status) {
      let checkedResult = true
      // 每个套餐内容都不会为空 则通过校验
      // 校验混堆名字重复
      checkedResult = this.checkName()
      if (!checkedResult) {
        return false
      }
      // 每个套餐内容都不会为空
      if (this.mixPackList.length) {
        this.mixPackList.forEach(item => {
          if (!item.stackPackSize || !item.tradePerfectScopeDetailList.length || !item.brandList || !item.defineName) {
            checkedResult = false
          }
          // if (status) {
          //   checkedResult = checkedResult && item.regionCodeList.length
          // }
          if (!checkedResult) {
            this.$message.warning({
              message: '请正确配置“' + this.title + '”部分数据',
              duration: 8000
            })
            checkedResult = false
          }
        })
      }
      return checkedResult
    }
  }
}
</script>

<style lang="scss" scoped>
.require {
  position: relative;
  &::before {
    content: '*';
    font-size: 20px;
    width: 5px;
    height: 5px;
    color: red;
    position: absolute;
    top: -10px;
    left: -10px;
  }
}
.iptSize {
  margin-right: 10px;
}
.wrapper {
  ::v-deep .el-button {
    padding: 8px 20px;
  }

  // ::v-deep .el-input__icon {
  //   height: 40px;
  // }
  position: relative;
  background-color: #fff;
  // height: 800px;
  .content {
    display: flex;
    justify-content: flex-start;
    line-height: 50px;
    color: #333;
    transition: height 0.5s;
    .title {
      display: flex;
      flex: none;
      width: 100%;
      // flex-basis: 14%;
      font-size: 16px;
      font-weight: 600;
      justify-content: space-between;
      div {
        // width: 100%;
        text-align: right;
      }
      .el-button {
        display: inline-block;
      }
    }
  }
  .info {
    position: relative;
    // min-height: 700px;
    .header {
      margin: 0 50px;
      box-sizing: border-box;
      line-height: 40px;
      border-radius: 5px;
      background: #eee;
    }
    .el-col {
      text-align: center;
    }
    .detail {
      min-height: 90px;
      border-bottom: 1px solid #ccc;
      padding: 10px 0;
      .center {
        justify-content: center;
      }
      .design-thumbnail {
        display: flex;
        // justify-content: center;
        overflow-x: auto;
        width: 100%;
        height: 100%;
        cursor: pointer;
        .design-thumbnail-column {
          display: inline-block;
        }
        .design-thumbnail-row {
          box-sizing: border-box;
          width: 25px;
          height: 25px;
          border: 1px solid #c0c4cc;
          border-radius: 3px;
        }
      }
      .design {
        text-align: center;
        .design-img {
          display: flex;
          flex-wrap: wrap;
          height: 100px;
          width: 100px;
          margin: 0 auto;
          // border: 1px solid #C0C4CC;
          border-radius: 8px;
          div {
            box-sizing: border-box;
            display: inline-block;
            border: 1px solid #c0c4cc;
            border-radius: 3px;
          }
        }
      }
      .region-wrapper {
        line-height: 30px;
        text-align: left;
        padding: 10px 0;
      }
    }
  }

  .pagination {
    text-align: center;
    padding: 20px 0;
  }
}
.el-select {
  width: 120px;
}
// 开放区域
.checkBox {
  margin-left: 100px!important;
  padding-left:0;
  margin-top: 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  .checkBox-title{
    flex-basis: 7%;
  }
  .checkBox-main{
   flex-basis: 78%;
  }
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}
::v-deep .el-checkbox__inner:hover {
  background-color: #409eff;
  border-color: #409eff;
}
::v-deep .isfocus {
  color: #409eff;
}
::v-deep .all .el-checkbox__inner {
  display: none;
}
::v-deep .el-checkbox__label {
  padding-left: 5px;
}
.all {
  padding: 0 20px 0 10px;
}
.color {
  color: #409eff !important;
}
.wrapper .info .checkBox {
  text-align: left;
  padding-left: 100px;
}
.product-info {
  font-size: 14px;
  padding: 5px 10px;
  color: #1b1c1d;
}
.stack-design-modify {
  cursor: pointer;
  color: red;
  line-height: 30px;
}
// ::v-deep .el-input__inner {
//   height: 30px;
// }
</style>
